import React from "react";
import {ResizableBox as ReactResizableBox} from "react-resizable";

import "react-resizable/css/styles.css";
import moment from "moment";

export default function ResizableBox({
	                                     children,
	                                     width = 1200,
	                                     height = 600,
	                                     resizable = true,
	                                     style = {},
	                                     className
                                     }) {
	return (
		<div>
			{resizable ? (
				<ReactResizableBox width={width} height={height}>
					<div
						style={{
							...style,
							width: "100%",
							height: "100%"
						}}
						className={className}
					>
						{children}
					</div>
				</ReactResizableBox>
			) : (
				<div
					style={{
						width: `${width}px`,
						height: `${height}px`,
						...style
					}}
					className={className}
				>
					{children}
				</div>
			)}
		</div>
	);
}

export function sumKey(array, keyName) {
	let sum = 0;
	array.forEach(item => {
		sum += item.data[keyName].sum
	})
	return sum;
}

/*export function sumValue(ob, type, stack) {
	if (type !== stack) return 0
	return Object.values(ob).reduce((acc, val) => acc + val, 0)
}*/

export function sumValue(sorted, labels, type) {
	let array = [];
	let typeArray = sorted.filter(elem => elem.type === type)
	labels.forEach(label => {
		typeArray.forEach(typeElem => {
			if (label === moment(typeElem.label).format("DD/MM/YYYY")) {
				array.push(typeElem.data["PFIZER"])
			}
		})
	})
	return array;
}

export const radarOptions = {
	scales: {
		r: {
			angleLines: {
				display: true
			},
			suggestedMin: 0,
			pointLabels: {
				font: {
					size: 16
				}
			}
		},
	},
	plugins: {
		legend: {
			labels: {
				// This more specific font property overrides the global property
				font: {
					size: 18
				}
			}
		}
	}
}
